@if (tileOrder?.length > 1) {
  <div class="sort-header-row">
    <span class="spacer"><i class="fa-solid fa-grip-dots"></i></span>
    <span class="spacer icon-spacer"></span>

    <div
      class="sort-header"
      role="button"
      tabindex="0"
      (click)="sortById()"
      (keydown.enter)="sortById()"
      (keydown.space)="sortById(); $event.preventDefault()"
    >
      <span>Tile ID</span>

      @switch (activeSortDirection) {
        @case ('up') {
          <span class="sort-icon"><i class="fa-duotone fa-solid fa-sort-up"></i></span>
        }
        @case ('down') {
          <span class="sort-icon"><i class="fa-duotone fa-solid fa-sort-down"></i></span>
        }
        @default {
          <span class="sort-icon"><i class="fa-solid fa-sort"></i></span>
        }
      }
    </div>
  </div>
}

<div
  cdkDropList
  [id]="listIdForCdk"
  [cdkDropListConnectedTo]="connectedListIdsForCdk"
  [cdkDropListData]="tileOrder"
  (cdkDropListDropped)="drop($event)"
  class="sortable-items"
>
  @for (tileId of tileOrder; track tileId) {
    <div
      class="sortable-item"
      cdkDrag
    >
      @if (tileExists(tileId)) {
        <div class="tile-item">
          <div
            class="grip-icon"
            cdkDragHandle
          >
            <i class="fa-solid fa-grip-dots"></i>
          </div>

          <motn-tile-icon [appearance]="tiles[tileId].Appearance"></motn-tile-icon>

          <motn-pill
            [squareLetter]="'t'"
          >{{ tileId }}</motn-pill>

          <div class="tile-name">
            <span class="name-text">{{tiles[tileId].Name}}</span>
            @let facetText = getFacetText(tileId);
            @if (facetText) {
              <span class="tile-facets">{{ facetText }}</span>
            }
          </div>
        </div>
      } @else {
        <div class="tile-item deleted">
          <div
            class="grip-icon"
            cdkDragHandle
          >
            <i class="fa-solid fa-grip-dots"></i>
          </div>

          <motn-pill
            [squareLetter]="'t'"
          >{{ tileId }}</motn-pill>

          <div class="tile-name">
            (deleted) will be removed on next save
          </div>
        </div>
      }

      @if (isDataPointsViewMode && tileExists(tileId)) {
        @if (isHiddenTile(tileId)) {
          <div
            (click)="showTile(tileId)"
            class="hidden-tile"
            title="Hidden eye"
          >
            <i class="fa-solid fa-eye-slash"></i>
          </div>
        } @else {
          <div
            (click)="hideTile(tileId)"
            class="visible-tile"
            title="Visible eye"
          >
            <i class="fa-solid fa-eye"></i>
          </div>
        }
      }

      <div
        class="delete"
        (click)="onClickX(tileId)"
        title="Remove tile"
      >
        <i class="fa-solid fa-minus"></i>
      </div>
    </div>
  }
</div>

@if (selectableTilesOptionGroup?.options.length) {
  <div class="add-tile">
    <button
      (click)="openTilesMenu()"
      class="small"
    >
      Add/Remove Tiles
    </button>

    <div class="label">
      <div>
        Drag and drop tiles using the
        <i class="fa-solid fa-grip-dots"></i>
        symbol to re-order {{connectedListIdsForCdk ? 'and move between groups' : ''}}
      </div>
    </div>

    @if (menuOpen) {
      <motn-popover-select-tiles
        [optionGroup]="selectableTilesOptionGroup"
        (clickedOption$)="onClickOption($event)"
        (clickedOutsideMenu$)="closeTilesMenu()"
      ></motn-popover-select-tiles>
    }

    <!--  <motn-popover-multi-select-->
    <!--    *ngIf="menuOpen"-->
    <!--    [inputPlaceholder]="'Tile Name or ID'"-->
    <!--    [optionGroup]="selectableTilesOptionGroup"-->
    <!--    (clickedOption$)="onClickOption($event)"-->
    <!--    (clickedOutsideMenu$)="closeTilesMenu()"-->
    <!--  ></motn-popover-multi-select>-->
  </div>
}
